
export class SizeMatrixFabricCodeDto {
    id?: number;
    imCode?:string;
    fit?:string;
    style?:string[];
    htColor?:string;
    fabricCode?:string;
    fabricContent?:string;
    fabricCombinations?:string[];
    createdUser?: string;
    isActive?:boolean
    versionFlag?: number;
    updatedUser?:string;
    updatedAt?:string;
    
    constructor( id?: number,imCode?:string,fit?:string,style?:string[],htColor?:string,fabricCode?:string,fabricContent?:string,fabricCombinations?:string[],createdUser?:string,isActive?:boolean,versionFlag?: number,updatedUser?:string,
     updatedAt?:string) {
      this.id = id;
      this.imCode = imCode;
      this.fit = fit;
      this.style= style;
      this.htColor = htColor
      this.fabricCode= fabricCode
      this.fabricContent = fabricContent
      this.fabricCombinations = fabricCombinations
      this.createdUser = createdUser;
      this.isActive = isActive;
      this.versionFlag = versionFlag;
      this.updatedUser = updatedUser;
      this.updatedAt = updatedAt;

    }
  }
  